import Navbar from "../../components/Navbar";
import Footer from "./sections/Footer";
import { Globe, Smartphone, CheckCircle, Sparkles, Shield } from "lucide-react";

export const servicesData = [
  {
    title: "خدمات مخصوص مشتریان",
    items: [
      {
        subtitle: "جستجوی هوشمند رستوران‌ها",
        icon: Globe,
        details: [
          "پیشنهاد نزدیک‌ترین رستوران",
          "نمایش رستوران‌های برتر بر اساس امتیاز",
          "فیلتر بر اساس نوع غذا (ایرانی، ایتالیایی، فست‌فود…)",
          "نمایش رستوران‌های محبوب، جدید، تخفیف‌دار",
          "نمایش فاصله و مسیر روی نقشه"
        ]
      },
      {
        subtitle: "مشاهده منوی دیجیتال رستوران",
        icon: Smartphone,
        details: [
          "مشاهده منو بدون نصب اپ",
          "اسکن QR کد روی میز",
          "تصاویر، توضیحات و قیمت کامل هر غذا",
          "مشاهده پرفروش‌ترین‌ها و پیشنهاد سرآشپز"
        ]
      },
      {
        subtitle: "سفارش‌دهی داخل سالن",
        icon: CheckCircle,
        details: [
          "ثبت سفارش بدون نیاز به گارسون",
          "افزودن آیتم‌ها به سبد",
          "درخواست گارسون، صورتحساب یا سرویس",
          "مشاهده زمان تقریبی آماده‌سازی"
        ]
      },
      {
        subtitle: "رزرو آنلاین میز",
        icon: Sparkles,
        details: [
          "انتخاب تاریخ و ساعت",
          "انتخاب تعداد نفرات",
          "مشاهده میزهای خالی",
          "دریافت پیامک یا نوتیفیکیشن تایید رزرو"
        ]
      }
    ]
  },
  {
    title: "خدمات ویژه رستوران‌ها و کافه‌ها",
    items: [
      {
        subtitle: "پنل مدیریت رستوران",
        icon: CheckCircle,
        details: [
          "مدیریت کامل منو (افزودن، حذف، ویرایش)",
          "مدیریت موجودی",
          "تعیین ساعات کار",
          "مشاهده گزارش فروش و آمارها",
          "مدیریت سفارش‌های داخل سالن و بیرون‌بر"
        ]
      },
      {
        subtitle: "ساخت منوی دیجیتال + QR اختصاصی",
        icon: Smartphone,
        details: [
          "طراحی QR با رنگ و برند رستوران",
          "منوی دیجیتال زیبا، واکنش‌گرا و سریع",
          "امکان افزودن تصویر، توضیحات و قیمت"
        ]
      },
      {
        subtitle: "سیستم سفارش‌گیری آنلاین",
        icon: Sparkles,
        details: [
          "سفارش از داخل سالن (میزها)",
          "سفارش بیرون‌بر (در صورت فعال‌سازی)",
          "سیستم نوتیفیکیشن برای آشپزخانه / گارسون",
          "اتصال به چاپگر آشپزخانه"
        ]
      },
      {
        subtitle: "سیستم رزرو میز برای رستوران",
        icon: Globe,
        details: [
          "مدیریت درخواست‌های رزرو",
          "تایید یا لغو رزرو",
          "گزارش رزروهای روز",
          "مدیریت ظرفیت سالن"
        ]
      }
    ]
  },
  {
    title: "خدمات ویژه پلتفرم",
    items: [
      {
        subtitle: "لیست جامع رستوران‌ها",
        icon: Globe,
        details: [
          "صفحه اختصاصی برای هر رستوران",
          "اطلاعات کامل شامل منو، عکس، قیمت، امتیاز، آدرس",
          "نمایش نظر کاربران"
        ]
      },
      {
        subtitle: "دسته‌بندی حرفه‌ای رستوران‌ها",
        icon: Sparkles,
        details: [
          "بر اساس نوع غذا",
          "بر اساس موقعیت جغرافیایی",
          "بر اساس قیمت، محبوبیت، امتیاز و تخفیف"
        ]
      },
      {
        subtitle: "سیستم امتیازدهی و نظرات",
        icon: CheckCircle,
        details: [
          "امتیازدهی به کیفیت غذا، محیط و برخورد",
          "ثبت تجربه کاربران",
          "نمایش بهترین رستوران‌ها"
        ]
      }
    ]
  },
  {
    title: "خدمات برندینگ و بازاریابی",
    items: [
      {
        subtitle: "ارتقا پروفایل رستوران",
        icon: Sparkles,
        details: [
          "نمایش در رستوران‌های برتر",
          "نمایش در بالای نتایج جستجو",
          "افزایش دیده‌شدن منو"
        ]
      },
      {
        subtitle: "تبلیغات درون‌برنامه‌ای",
        icon: Globe,
        details: [
          "بنر تخفیف",
          "کمپین‌های مناسبتی",
          "پیشنهاد ویژه به کاربران نزدیک"
        ]
      },
      {
        subtitle: "پشتیبانی ۲۴ ساعته",
        icon: Shield,
        details: ["چت، تماس و تیکت", "رفع سریع مشکلات"]
      },
      {
        subtitle: "امنیت داده‌ها",
        icon: Shield,
        details: [
          "حفظ اطلاعات کاربران",
          "امنیت پرداخت‌ها",
          "ارتباط رمزگذاری‌شده"
        ]
      }
    ]
  }
];

export default function ServicesPage() {
  return (
    <>
      <Navbar />

      {/* Hero */}
      {/* Hero ساده و سازگار */}
      <section className="py-24 bg-gradient-to-b from-secondary_1 via-white to-white border-b">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-6 text-gray-900">
            منوساز ساده و جامع
            <br />
            <span className="text-orange-500">برای انواع خدمات و مراکز غذایی</span>
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            بامیزبان پلتفرمی برای مدیریت دیجیتال رستوران و کافه است که نمایش منو، ثبت سفارش،
            رزرو میز و معرفی رستوران‌ها را در یک محیط ساده و سریع فراهم می‌کند.
          </p>
        </div>
      </section>


      {/* Intro */}
      {/* <section className="py-16 px-6 max-w-5xl mx-auto">
        <p className="text-gray-700 leading-relaxed text-justify">
          بامیزبان پلتفرمی برای مدیریت دیجیتال رستوران و کافه است که نمایش منو،
          ثبت سفارش، رزرو میز و معرفی رستوران‌ها را در یک محیط ساده و سریع فراهم
          می‌کند. بدون نیاز به دانش فنی، رستوران‌ها می‌توانند منوی خود را مدیریت
          کنند و مشتریان با چند کلیک بهترین انتخاب را داشته باشند.
        </p>
      </section> */}

      {/* Services */}
      <section className="py-16 px-6 max-w-6xl mx-auto space-y-16">
        {servicesData.map((section, idx) => (
          <div key={idx}>
            <h2 className="text-3xl font-bold text-center mb-10 text-gray-800">
              {section.title}
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              {section.items.map((item, i) => (
                <div key={i} className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center">
                      <item.icon size={22} />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-700">
                      {item.subtitle}
                    </h3>
                  </div>

                  <ul className="relative pr-4 border-r border-gray-300 space-y-2 text-gray-600">
                    <span className="absolute right-[-2px] top-1/2 -translate-y-1/2 w-1 h-8 bg-primary" />
                    {item.details.map((d, j) => (
                      <li key={j}>{d}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            {idx !== servicesData.length - 1 && (
              <hr className="my-14 border-gray-200" />
            )}
          </div>
        ))}
      </section>

      <Footer />
    </>
  );
}
